/**
 * DOM marker written by InlineScanCta so other surfaces can tell, at click time,
 * whether the page already offers an in-place photo picker to a given
 * destination. Read by the prose-CTA click handler in
 * components/ui/blog-content-with-toc.tsx to tag `competing_inline_cta`.
 *
 * Lives in its own module because the reader is a client component that must
 * not import the CTA component itself.
 */
export const SCAN_CTA_DESTINATION_ATTR = 'data-scan-cta-destination'
